<template>
     <div
          style="display: flex;flex-direction: column;align-items: center;width: 100%;background: #F5F5F5;overflow: auto;">
          <div style="width: calc(100% - 20px);padding: 10px ;display: flex;flex-direction: column;background: white;">
               <div style="color: grey;font-size: small;width: 100%;text-align: left;margin-top: 10px;">
                    {{ companyInfo.companyName }}</div>
               <div style="font-size: large;width: 100%;text-align: left;font-weight: 700;margin-top: 10px;">
                    {{ itemName }}</div>
               <div
                    style="margin-top: 10px;font-size: small;width: 100%;text-align: left;display: flex;align-items: center;">
                    <div style="color: grey;margin-right: 10px;">已选时间</div>
                    <div style="color:#FC5531 ;">未选择上门时间</div>
               </div>
               <div
                    style="margin-top: 10px;font-size: small;width: 100%;text-align: left;display: flex;align-items: center;">
                    <div style="color: grey;margin-right: 10px;">退改规则</div>
                    <div style="color:#FC5531 ;">上门前3小时可退，支持改订</div>
               </div>
          </div>
          <div style="margin-top: 10px;width: 100%;display: flex;flex-direction: column;background: white;">
               <div
                    style="box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);display: flex;align-items: center;width: calc(100% - 20px);padding: 10px;">
                    <img src="../assets/定位.png" style="width: 30px;height: 30px;" alt="">
                    <div v-if="selectedAddress == null" @click="gotoAddressManager" style="margin-left: 20px;flex: 1;">
                         请选择服务地址
                    </div>
                    <div v-if="selectedAddress != null" @click="gotoAddressManager" style="
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                        margin: 0 10px;
                    ">
                         <div style="text-align: left;font-weight: 700;">{{ selectedAddress.location }}</div>
                         <div style="text-align: left;color:grey">{{ selectedAddress.detailAddress }}</div>
                         <div style="display: flex;align-items: center;color:grey;font-size: small;">
                              <div style="margin-right: 20px;">{{ selectedAddress.contact }}</div>
                              <div>{{ selectedAddress.phoneNumber }}</div>
                         </div>
                    </div>
                    <div @click="gotoAddressManager"
                         style="display: flex;flex-direction: column;align-items: center;background: #FCBC23;border-radius: 5px;">
                         <img src="../assets/地址簿.png" style="width: 30px;height: 30px;margin: 5px;" alt="">
                         <div style="padding: 0 10px;color: white;">地址簿</div>
                    </div>

               </div>
               <div id="container" style="width: 100%;height: 300px;"></div>
          </div>



          <div
               style="margin-top: 10px;width: calc(100% - 20px);padding: 10px ;display: flex;flex-direction: column;background: white;">

               <div style="font-size: large;width: 100%;text-align: left;font-weight: 700;">
                    预订</div>
               <div
                    style="margin-top: 10px;font-size: small;width: 100%;text-align: left;display: flex;align-items: center;">
                    <div style="color: grey;margin-right: 10px;">上门时间</div>
                    <div style="color:#FC5531 ;">已为您优先展示最早可订的时间</div>
               </div>
               <div
                    style="margin-top: 10px;width: 100%;display: flex;align-items: center;border-bottom: solid 5px #F5F5F5;padding: 10px 0;border-top: solid 5px #F5F5F5;">
                    <div v-for="item, index in next7Days" :key="index"
                         style="display: flex;flex-direction: column;flex: 1;" :style="{
                              background: selectedDate == index ? '#FC5531' : 'white',
                              color: selectedDate == index ? 'white' : 'black',
                              borderRadius: '5px'
                         }" @click="changeSelectedDate(index)">
                         <div style="font-weight: 700;">{{ item.isToday ? '今天' : item.weekday }}</div>
                         <div style="margin: 5px 0;">{{ item.dateString }}</div>
                    </div>
               </div>
               <div style="margin-top: 10px;width: 100%;display: flex;flex-direction: column;">
                    <div style="display: flex;align-items: center;">
                         <div style="flex: 1;" :style="{ color: selectedHalfDay == 0 ? '#FC5531' : 'black' }"
                              @click="changeSelectedHalfDay(0)">上午</div>
                         <div style="flex: 1;" :style="{ color: selectedHalfDay == 1 ? '#FC5531' : 'black' }"
                              @click="changeSelectedHalfDay(1)">下午</div>
                    </div>
               </div>
               <div style="margin-top: 10px;width: 100%;display: flex;flex-wrap: wrap;">
                    <div v-for="item, index in bookingList" style="
                    width: calc(33% - 22px);
                    font-weight: 700;
                    background: #F5F5F5;
                    color: #999999;
                    border-radius: 5px;
                    margin: 5px;
                    padding: 5px;
                    border: solid 1px #ccc;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    " :style="{
                         background: (selectedTime === index) ? '#F7E2DC' : '#F5F5F5',
                         border: (selectedTime === index) ? 'solid 1px #F5F5F5' : 'solid 1px #ccc',
                         color: (selectedTime === index) ? '#FC5531' : '#999999'
                    }" @click="selectBookingTime(index)" :key="index">
                         <div>{{ item.start.substring(0, 5) }}-{{ item.end.substring(0, 5) }}</div>
                         <div>{{ item.freeServers == null ? '不可约' : "可约" }}</div>
                    </div>
               </div>

          </div>

          <div style="margin-top: 10px;width: calc(100% - 20px);padding: 10px ;display: flex;background: white;">
               <div>备注</div>
               <textarea style="flex: 1;margin-left: 10px;height: 100px;border: none;outline: none;">

               </textarea>
          </div>
          <div style="margin: 10px 0;width: calc(100% - 20px);padding: 10px;display: flex;">
               <button @click="submitOrder"
                    style="background: #FC5531;color: white;border-radius: 5px;font-weight: 700;padding: 10px 20px;border: none;">下一步，确认订单</button>
          </div>
     </div>
</template>

<style scoped></style>

<script>
import request from "../axios/request";
// import { mapState } from "vuex";
export default {
     name: "HomeServiceOrder",
     props: {
          companyId: {
               type: Number,
               required: true,
          },
          itemName: {
               type: String,
               required: true,
          },
          itemHeadImg: {
               type: String,
               required: false,
               default: '',
          },
          itemId: {
               type: Number,
               required: false,
          },
          itemPrice: {
               type: Number,
               required: false,
          },
     },
     // computed: {
     //      ...mapState(['selectedAddress']),
     // },
     data() {
          return {
               timer: null,
               companyInfo: null,
               bookingList: null,
               next7Days: [],
               selectedDate: 0,
               selectedHalfDay: 0,
               selectedTime: null,
               selectedAddress: null,
               markerLayer: null,
               polylineLayer: null,
               map: null,
               aimAddress: {
                    address: "目的地"
               },
               companyLat: null,
               companyLng: null
          }
     },
     beforeDestroy() {
          clearInterval(this.timer);
     },
     mounted() {
         
          this.next7Days = this.generateNextNDates(7, true);
          
          this.getCompanyDetailByCompanyId();
          this.getItemBookingListByItemIdAndDate();
          this.getDefaultAddress();
     },
     methods: {
          async routePlan() {
               // 计算途经点
               let waypoints = ""


               let res = await request({
                    url: "/amap/api/driving?" +
                         "fromLat=" + this.companyLat + "&" +
                         "fromLng=" + this.companyLng + "&" +
                         "toLat=" + this.aimAddress.lat + "&" +
                         "toLng=" + this.aimAddress.lng + (waypoints == "" ? "" : "&waypoints=" + waypoints),
                    method: "GET"
               })
               if (res.data.status == 200) {
                    
                    let result = res.data.data
                    
                    this.displayPolyline(result.result.routes[0].polyline); // 绘制路径折线
               }
          },
          displayPolyline(coors) {
           

               let pl = []
               //坐标解压（返回的点串坐标，通过前向差分进行压缩，因此需要解压）
               let kr = 1000000;
               for (let i = 2; i < coors.length; i++) {
                    coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr;
               }
               //将解压后的坐标生成LatLng数组
               for (let i = 0; i < coors.length; i += 2) {
                    pl.push(new MapKit.LatLng(coors[i], coors[i + 1]));
               }
               pl.unshift(new MapKit.LatLng(this.companyLat, this.companyLng))
               
               let copyOrderInfoList = []

               copyOrderInfoList.push(
                    {
                         styleId: "start",
                         position: new MapKit.LatLng(this.companyLat, this.companyLng),
                         properties: {
                              title: "起点"
                         }
                    }
               )
               copyOrderInfoList.push(
                    {
                         styleId: "end",
                         position: new MapKit.LatLng(this.aimAddress.lat, this.aimAddress.lng),
                         properties: {
                              title: "终点"
                         }
                    }
               )
               

               this.markerLayer.setGeometries([])
               this.markerLayer.updateGeometries(copyOrderInfoList)

               this.polylineLayer.updateGeometries([
                    {
                         id: 'pl_1',
                         styleId: 'style_blue',
                         paths: pl,
                    },
               ])
          },
          async submitOrder() {
               if (this.selectedAddress == null) {
                    alert("请选择服务地址");
                    return;
               }
               if (this.selectedTime == null) {
                    alert("请选择上门时间");
                    return;
               }
               const slot = this.bookingList[this.selectedTime]
               if (this.submittingOrder) return
               this.submittingOrder = true
               try {
               const res = await request({ url: '/order/api/createServerOrder', method: 'POST', data: {
                    companyId: this.companyId,
                    addressId: this.selectedAddress.id,
                    itemList: [{ itemId: this.itemId, quantity: 1 }],
                    date: this.next7Days[this.selectedDate].dateString,
                    start: slot.start,
                    end: slot.end,
                    serviceMode: 0
               } })
               if (res.data.status === 200) this.$emit('createOrder', res.data.data)
               } finally { this.submittingOrder = false }
          },
          async getDefaultAddress() {
               if (this.$store.state.selectedAddress == null) {
                    let res = await request({
                         url: "/user/api/getDefaultAddressDetail",
                         method: "GET"
                    })
                    if (res.data.status == 200) {
                         this.selectedAddress = res.data.data;
                    }
               } else {
                    this.selectedAddress = this.$store.state.selectedAddress;
               }
               if (this.selectedAddress == null) {
                    this.$message.warning('请先添加并选择服务地址')
                    return
               }
               this.aimAddress = {
                    lat: this.selectedAddress.lat,
                    lng: this.selectedAddress.lng
               }
               setTimeout(() => {
                    this.initAMap()
               }, 2000)
             

          },
          initAMap() {
               let that = this
              
               let center = new MapKit.LatLng(that.companyLat, that.companyLng)
               //     定义map变量，调用 MapKit.Map() 构造函数创建地图
               that.map = new MapKit.Map(document.getElementById('container'), {
                    center: center,//设置地图中心点坐标
                    zoom: 15,   //设置地图缩放级别

               });
               that.polylineLayer = new MapKit.MultiPolyline({
                    id: 'polyline-layer',
                    map: that.map,
                    styles: {
                         style_blue: new MapKit.PolylineStyle({
                              color: '#3777FF',
                              width: 8,
                              borderWidth: 5,
                              borderColor: '#FFF',
                              lineCap: 'round',
                         }),
                    }
               });
               that.markerLayer = new MapKit.MultiMarker({
                    map: that.map,  //指定地图容器
                    //样式定义
                    styles: {
                         //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                         "myStyle": new MapKit.MarkerStyle({
                              "width": 25,  // 点标记样式宽度（像素）
                              "height": 35, // 点标记样式高度（像素）
                              // "src": require('../assets/返回.png'),  //图片路径
                              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                              "anchor": { x: 16, y: 32 }
                         }),
                         start: new MapKit.MarkerStyle({
                              width: 25,
                              height: 35,
                              anchor: { x: 16, y: 32 },
                              src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png',
                         }),
                         end: new MapKit.MarkerStyle({
                              width: 25,
                              height: 35,
                              anchor: { x: 16, y: 32 },
                              src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png',
                         }),
                    }

               });
               this.routePlan()
          },
          gotoAddressManager() {
               this.$router.push({
                    path: "/address"
               })
          },
          selectBookingTime(index) {
               if (this.bookingList[index].freeServers == null) {
                    return;
               }
               this.selectedTime = index;
          },
          changeSelectedHalfDay(halfDay) {
               this.selectedHalfDay = halfDay;
               this.selectedTime = null;
               this.getItemBookingListByItemIdAndDate();
          },
          async changeSelectedDate(index) {
               this.selectedDate = index;
               this.selectedTime = null;
               this.getItemBookingListByItemIdAndDate();
          },
          generateNextNDates(days = 7, includeToday = true) {
               const dates = [];
               const today = new Date();
               const start = includeToday ? 0 : 1;

               for (let i = start; i < start + days; i++) {
                    const date = new Date(today);
                    date.setDate(today.getDate() + i);

                    dates.push({
                         date: date,  // Date对象
                         dateString: this.formatDate(date, 'MM/dd'),  // 格式: 04/17
                         weekday: this.getChineseWeekday(date),       // 星期几
                         shortWeekday: this.getShortWeekday(date),    // 周几
                         isToday: i === 0,                       // 是否是今天
                         isWeekend: date.getDay() === 0 || date.getDay() === 6,  // 是否是周末
                         timestamp: date.getTime()               // 时间戳
                    });
               }

               return dates;
          },
          formatDate(date, format = 'MM/dd') {
               const month = (date.getMonth() + 1).toString().padStart(2, '0');
               const day = date.getDate().toString().padStart(2, '0');
               const year = date.getFullYear();
               const hours = date.getHours().toString().padStart(2, '0');
               const minutes = date.getMinutes().toString().padStart(2, '0');

               return format
                    .replace('YYYY', year)
                    .replace('MM', month)
                    .replace('dd', day)
                    .replace('HH', hours)
                    .replace('mm', minutes);
          },
          getChineseWeekday(date) {
               const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
               return weekdays[date.getDay()];
          },
          getShortWeekday(date) {
               const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
               return weekdays[date.getDay()];
          },
          getEnglishWeekday(date) {
               const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
               return weekdays[date.getDay()];
          },

          async getItemBookingListByItemIdAndDate() {
               // 这里应该调用接口获取服务器详情，目前先模拟数据
               let res = await request({
                    url: "/item/api/getItemBookingListByItemIdAndDate?itemId=" + this.itemId + "&date=" + this.next7Days[this.selectedDate].dateString + "&halfDay=" + this.selectedHalfDay,
                    method: 'GET'
               });
               if (res.data.status == 200) {
                    this.$nextTick(() => {
                         this.bookingList = res.data.data;
                    });
               }
          },
          async getCompanyDetailByCompanyId() {
               // 这里应该调用接口获取服务器详情，目前先模拟数据
               let res = await request({
                    url: "/company/api/getCompanyDetailByCompanyId?serverId=" + this.companyId,
                    method: 'GET'
               });
               if (res.data.status == 200) {
                    this.$nextTick(() => {
                         this.companyInfo = res.data.data;
                    
                         this.companyLat = this.companyInfo.lat;
                         this.companyLng = this.companyInfo.lng;
                    });
               }
          }
     }
}
</script>
